/**
 * What a figure reads as when the app does not know it.
 *
 * Distinct from zero, which is a claim. A brand with no applications yet has
 * genuinely received none and should see 0; a brand whose applications failed
 * to load has received an unknown number, and showing 0 there would be a wrong
 * answer rather than a missing one.
 *
 * Shared by the creator dashboard (PIT-72) and the brand dashboard (PIT-84),
 * which reached the same convention independently.
 */
export const STAT_PLACEHOLDER = '—';
